import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class HillsLookoutTowerBuildingTileEntity extends TileEntity {
	public static readonly frameName = FrameName.HILLS_LOOKOUT_TOWER;
}

export default HillsLookoutTowerBuildingTileEntity;
